import { useCallback, useEffect, useState } from 'react';

/**
 * Gerencia quais grupos do menu estão abertos (submenu expandido).
 * Abre automaticamente o grupo que contém a rota ativa.
 * Reseta ao colapsar a sidebar.
 *
 * @param {Object} params
 * @param {string} params.pathname - Rota atual (location.pathname)
 * @param {Array<{key: string, children: Array<{to: string}>}>} params.allGroups
 *        Todos os grupos que devem ser monitorados pro auto-open
 * @param {boolean} params.collapsed - Se a sidebar está colapsada
 * @returns {{
 *   openGroups: Object.<string, boolean>,
 *   toggleGroup: (key: string) => void,
 *   resetGroups: () => void
 * }}
 */
export default function useOpenGroups({ pathname, allGroups, collapsed }) {
   const [openGroups, setOpenGroups] = useState({});

   const toggleGroup = useCallback((key) => {
      setOpenGroups((prev) => ({ ...prev, [key]: !prev[key] }));
   }, []);

   const resetGroups = useCallback(() => setOpenGroups({}), []);

   // Abre automaticamente o grupo da rota ativa (só quando expandido)
   useEffect(() => {
      if (collapsed) return;
      const openGroupsWithActiveRoute = {};
      allGroups.forEach((group) => {
         const hasActive = group.children.some((c) => c.to === pathname);
         if (hasActive) openGroupsWithActiveRoute[group.key] = true;
      });
      if (Object.keys(openGroupsWithActiveRoute).length) {
         setOpenGroups((prev) => ({ ...prev, ...openGroupsWithActiveRoute }));
      }
   }, [pathname, collapsed, allGroups]);

   return { openGroups, toggleGroup, resetGroups };
}
